import _ from 'lodash';
import classNames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';

import history from 'config/history';

import logo from 'assets/images/logo.svg';

import {
  HOME_URL,
  MODALS,
  GLOBAL_SEARCH_URL,
  DASHBOARD_URL
} from 'global-constants';

import WithUser from 'shared/HOCs/WithUser';

import { openModal, isModalOpen } from 'shared/components/Modals/reducer';
import SignupModal from 'shared/components/SignupModal';
import Button from 'shared/components/Button';
import LoginModal from 'shared/components/LoginModal';
import ForgotPasswordModal from 'shared/components/ForgotPasswordModal';
import ChangePlanModal from 'shared/components/ChangePlanModal';
import SuccessChangePlanModal from 'shared/components/ChangePlanModal/SuccessChangePlanModal';
import { PLAN_TYPES } from 'shared/components/ChangePlanModal/constants';
import GlobalSearchInput from 'shared/components/GlobalSearchInput';
import SendMessagesModal from 'shared/components/SendMessagesModal';
import NewButton from 'shared/components/NewButton';

import { getImageStyle } from 'shared/utils/getImageStyle';
import { userHasPlan } from 'shared/utils/userPlanCheck';
import GlobalNotifier from 'pages/Messaging/GlobalNotifier';

import ProfileDropDown from './ProfileDropDown';
import MobileNav from './MobileNav';
import NavLinks from './NavLinks';

import defaultAvatar from 'assets/images/default-avatar.png';

import styles from './styles.module.scss';

class Navigation extends React.Component {
  state = {
    isProfileOpen: false,
    isNavigationOpen: false,
    isOpenGlobalSearchInput: false,
    shrinkNavigation: false
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  toggleNavigation = () => {
    this.setState(prevState => ({
      isNavigationOpen: !prevState.isNavigationOpen
    }));
  };

  toggleGlobalSearchInput = () => {
    this.setState(prevState => ({
      isOpenGlobalSearchInput: !prevState.isOpenGlobalSearchInput
    }));
  };

  openProfile = () => {
    this.setState({ isProfileOpen: true });
  };

  closeProfile = () => {
    this.setState({ isProfileOpen: false });
  };

  isUserLoggedIn = () =>
    !_.isNil(this.props.user) && !_.isEmpty(this.props.user);

  redirectToGlobalSearchOrSubmit = data => {
    if (!_.isEmpty(data)) {
      if (history.location.pathname !== GLOBAL_SEARCH_URL) {
        this.props.push(`${GLOBAL_SEARCH_URL}?search=${data.search}`);
      } else {
        this.props.submitGlobalSearch(data);
      }
      this.setState({ isOpenGlobalSearchInput: false });
    }
  };

  mobileToGlobalSearchOrSubmit = data => {
    this.redirectToGlobalSearchOrSubmit(data);
    if (!_.isEmpty(data)) this.toggleNavigation();
  };

  handleScroll = event => {
    const verticalScroll = window.scrollY;

    this.setState({ shrinkNavigation: verticalScroll > 100 });
  };

  render() {
    const { shrinkNavigation } = this.state;
    const { openModal, user, className } = this.props;

    const avatarStyle = getImageStyle({
      image: _.get(user, 'profile.avatar'),
      thumbnails: _.get(user, 'profile.thumbnails'),
      height: 43,
      width: 43,
      defaultImage: defaultAvatar,
      backgroundSize: 'contain'
    });

    const homeUrl = _.isEmpty(user) ? HOME_URL : DASHBOARD_URL;

    const notificationAlertCount = _.get(user, 'unseen_notifications_count', 0);

    return (
      <div
        className={classnames(
          styles.navigationContainer,
          { [styles.shrink]: shrinkNavigation },
          className
        )}>
        <div className={styles.navigation}>
          <div className={styles.left}>
            <div className={styles.logoContainer}>
              <NavLink to={homeUrl}>
                <img src={logo} alt="logo" />
              </NavLink>
            </div>
            {!this.state.isOpenGlobalSearchInput && (
              <NavLinks wrapperClassname="remove-sm" user={user} />
            )}
            {this.state.isOpenGlobalSearchInput && (
              <div
                className={classnames(
                  styles.globalSearchInputWrapper,
                  'remove-sm'
                )}>
                <GlobalSearchInput
                  submitAction={this.redirectToGlobalSearchOrSubmit}
                  isNav={true}
                />
              </div>
            )}
          </div>
          <div className={styles.right}>
            <div
              className={classnames('remove-sm', styles.searchIcon)}
              onClick={this.toggleGlobalSearchInput}>
              <i className="material-icons">
                {!this.state.isOpenGlobalSearchInput ? 'search' : 'close'}
              </i>
            </div>

            {_.isEmpty(user) ? (
              <React.Fragment>
                <div
                  className={classNames('remove-sm', styles.signInLabel)}
                  onClick={() =>
                    openModal({
                      modalName: MODALS.LOGIN
                    })
                  }>
                  Sign in
                </div>
                <Button
                  id="sign-up-for-free-button"
                  color="primary"
                  onClick={() =>
                    openModal({
                      modalName: MODALS.SIGNUP
                    })
                  }
                  type="submit">
                  Sign up
                  <span className="remove-sm"> for free</span>
                </Button>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <GlobalNotifier
                  notificationAlertCount={notificationAlertCount}
                />

                <div className={classNames(styles.right, 'remove-sm')}>
                  {userHasPlan(user, PLAN_TYPES.FREE) && (
                    <NewButton
                      color="orangeGradient"
                      className={styles.navBtn}
                      onClick={() =>
                        openModal({
                          modalName: MODALS.CHANGE_PLAN
                        })
                      }>
                      Data Explorer
                    </NewButton>
                  )}

                  <div
                    onMouseOver={this.openProfile}
                    onMouseLeave={this.closeProfile}
                    className={styles.profileTrigger}>
                    <div
                      className={classnames(styles.avatar, {
                        [styles.openDropdown]: this.state.isProfileOpen
                      })}
                      style={avatarStyle}
                    />
                    <ProfileDropDown
                      closeHandler={this.closeProfile}
                      isOpen={this.state.isProfileOpen}
                    />
                  </div>
                </div>
              </React.Fragment>
            )}
            <i
              className={classnames('material-icons', styles.menuToggle)}
              onClick={this.toggleNavigation}>
              menu
            </i>
          </div>
          <div
            className={classnames(styles.menuDimmer, 'remove-md-min', {
              [styles.opened]: this.state.isNavigationOpen
            })}>
            <MobileNav
              notificationAlertCount={notificationAlertCount}
              closeNavigation={this.toggleNavigation}
              redirectToGlobalSearchOrSubmit={this.mobileToGlobalSearchOrSubmit}
            />
          </div>
        </div>
        {this.props.isSignUpOpen && <SignupModal />}
        {this.props.isLoginOpen && <LoginModal />}
        {this.props.isForgotPasswordOpen && <ForgotPasswordModal />}
        {this.props.isChangePlanModalOpen && <ChangePlanModal />}
        {this.props.isSuccessChangePlanModalOpen && <SuccessChangePlanModal />}
        {this.props.isSendMessagesModalOpen && <SendMessagesModal />}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isSignUpOpen: isModalOpen(state, MODALS.SIGNUP),
    isLoginOpen: isModalOpen(state, MODALS.LOGIN),
    isForgotPasswordOpen: isModalOpen(state, MODALS.FORGOT_PASSWORD),
    isChangePlanModalOpen: isModalOpen(state, MODALS.CHANGE_PLAN),
    isSuccessChangePlanModalOpen: isModalOpen(
      state,
      MODALS.SUCCESS_CHANGE_PLAN
    ),
    isSendMessagesModalOpen: isModalOpen(state, MODALS.SEND_MESSAGES_MODAL)
  };
};

export default WithUser(
  connect(
    mapStateToProps,
    { push, openModal }
  )(Navigation)
);
